export default props => {
  if(props.test) {
    return props.children
  } else {
    return false
  }
}


// WEBPACK FOOTER //
// ./src/components/atoms/If/index.js